import React, { useEffect, useState } from "react";
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    Badge,
    MenuItem,
    Menu,
    Avatar,
    Tooltip,
    Button
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/icons/Final_Logo.png";
import LogoMm from "../../assets/images/logomm.jpg";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Grid from "@mui/material/Grid2";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { ThreeDot } from "react-loading-indicators";
import Brightness1Icon from "@mui/icons-material/Brightness1";

import { notificationUpdateReadStatusApi } from "../../Sourcing/Services/Notification/Notification";
import PartnerDetailsDrawer from "../../Sourcing/Partner/PartnerDetails/PartnerDetailsDrawer";
import {
    generatePartnerRegistrationFile,
    generatProfilePicUrl,
    getLoggedInEmail,
    getLoggedInUserEmail
} from "../../Utils/Constant";
import {
    getNotification,
    updateNotificationReadStatus
} from "../../AccountManagement/Services/Notification";
import DOMPurify from "dompurify";
import { LogoutApi } from "../../Sourcing/Services/User/Login";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const currentVersion = process.env.REACT_APP_VERSION;
interface HeaderProps {
    toggleSidebar: () => void;
    updateIsReadStatus: boolean;
    setUpdateIsReadStatus: (value: boolean) => void;
    webSocketMessage: string | string[];
    isLoggedIn: boolean;
}

const Header: React.FC<HeaderProps> = ({
    toggleSidebar,
    updateIsReadStatus,
    setUpdateIsReadStatus,
    webSocketMessage,
    isLoggedIn
}) => {
    interface Notification {
        ID: string;
        IDKey: string;
        notificationType: string;
        new: boolean;
        logo: string;
        department: string;
        role: string;
        subjectMessage: string;
        bodyMessage: string;
        addedTime: string;
        notificationID: string;
        logoID: string;
        imageUrl: string;
        Bell_Icon_Clicked_at: string;
    }
    const location = useLocation();
    const isHome = location?.pathname?.includes("/layout");
    const isDownTime = location?.pathname
        ?.toLowerCase()
        .includes("downtimescreen");
    const isTextColorBlack = isHome || isDownTime;
    const [showSearch, setShowSearch] = useState<Boolean>(false);
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const [count, setCount] = useState<Number>(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const open = Boolean(anchorEl);
    const [anchorElP, setAnchorElP] = useState(null);
    const openProfile = Boolean(anchorElP);
    const navigate = useNavigate();
    const [isInitialRender, setIsInitialRender] = useState(true);

    const [openD, setOpenD] = React.useState(false);

    const handleClickOpenD = () => {
        setOpenD(true);
    };

    const handleCloseD = () => {
        setOpenD(false);
    };

    const notificationUpdateReadStatus = async (id: string) => {
        try {
            const updateData = await notificationUpdateReadStatusApi({
                notifierID: id
            });
            if (updateData?.status) {
                updateIsReadStatus === true
                    ? setUpdateIsReadStatus(false)
                    : setUpdateIsReadStatus(true);
            }
        } catch (error) {
            console.log("eeeeeeeeeeeee", error);
        }
    };
    const handleOpenDrawer = async (row) => {
        row.unique_ID = row?.ID;
        row.navigatingFrom = "Partner Database";
        setSelectedRow(row);
        setOpenDrawer(true);
        setAnchorEl(null);
    };

    const handleNavigation = (notification) => {
        if (
            notification?.ID &&
            notification?.notificationType.includes("Partner")
        ) {
            handleOpenDrawer(notification);
        } else if (notification?.notificationType === "COPO_Creation") {
            navigate("/layout/CoPoDatatable");
        } else if (
            notification?.subjectMessage === "Reminder on Approving Quotes" ||
            notification?.subjectMessage === "New Quote Alert" ||
            notification?.subjectMessage === "Quote Approved"
        ) {
            navigate("/layout/AllMmrfq", {
                state: {
                    rfqData: {
                        ID: notification?.ID,
                        rfqID: notification?.IDKey,
                        notificationID: notification?.notificationID,
                        assigneeName: notification?.requestedFrom
                    }
                }
            });
        } else if (
            notification?.notificationType === "RFQ_Approved" ||
            notification?.subjectMessage.includes("Partner(s) Approved")
        ) {
            navigate("/layout/FRfqList");
        } else if (
            notification?.subjectMessage === "Company RFQ Ready for Proposal"
        ) {
            navigate("/layout/Proposals");
        } else if (
            notification?.IDKey &&
            !notification?.bodyMessage.includes("unassigned")
        ) {
            const fromSource =
                notification?.department === "Sourcing" &&
                notification?.role === "Level 2 Manager" &&
                notification?.department === "Sourcing" &&
                notification?.role === "Level 1 Manager"
                    ? "CURFQAssignedToMe"
                    : "CompanyRfq";
            navigate("/layout/CURFQDetails", {
                state: {
                    rfqData: {
                        ID: notification?.ID,
                        rfqID: notification?.IDKey,
                        message: notification?.subjectMessage
                    },
                    from: fromSource
                }
            });
        } else if (
            notification?.IDKey &&
            notification?.bodyMessage.includes("unassigned")
        ) {
            const fromSource =
                notification?.department === "Sourcing" &&
                notification?.role === "Level 2 Manager" &&
                notification?.department === "Sourcing" &&
                notification?.role === "Level 1 Manager"
                    ? "CURFQAssignedToMe"
                    : "CompanyRfq";
            navigate("/layout/CURFQAssignedToMe", {});
        }
        setAnchorEl(null);
        if (notification?.new) {
            notificationUpdateReadStatus(notification?.notificationID);
        }
    };

    // Function to close drawer
    const handleCloseDrawer = () => {
        setOpenDrawer(false);
    };
    const handleClick = async (event) => {
        setAnchorEl(event?.currentTarget);
        await fetchNotification();
        try {
            let getIDs = notifications
                .filter((item) => item?.Bell_Icon_Clicked_at === "No")
                .map((item) => item.notificationID);
            if (getIDs.length > 0) {
                const updateReadStatus = await updateNotificationReadStatus({
                    notificationIDs: getIDs
                });
                setCount(0);
            }
        } catch (error) {
            console.log("error while updating notification read status");
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickProfile = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElP(event?.currentTarget);
    };

    const handleSignOut = async () => {
        (window as any).isLoggingOut = true;
        try {
            const resposnse = await LogoutApi({
                email: getLoggedInUserEmail()
            });
            console.log("logout successfully");
        } catch (err) {
            console.log("error while logouting");
        } finally {
            localStorage.clear();
            window.location.reload();
        }
    };

    const fetchNotification = async () => {
        if (getLoggedInEmail()) {
            setLoading(true);
            try {
                const data = await getNotification(getLoggedInEmail());
                if (data?.status) {
                    const notificationCount =
                        data?.data?.filter(
                            (item) =>
                                item?.new === true &&
                                item?.Bell_Icon_Clicked_at === "No"
                        ).length || 0;
                    setCount(notificationCount);
                    const updatedNotifications = data?.data?.map(
                        (notification) => ({
                            ...notification,
                            imageUrl: handleDisplayLogo(notification) // ensure this is NOT async
                        })
                    );
                    setNotifications(updatedNotifications);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        try {
            if (!webSocketMessage) return; // Prevent parsing if it's undefined or null

            const message = Array.isArray(webSocketMessage)
                ? webSocketMessage[0]
                : webSocketMessage;

            if (typeof message !== "string") {
                console.log("Invalid JSON: Not a string", message);
                return;
            }

            const websocketMessageParse = JSON.parse(message);
            if (websocketMessageParse.type === "new_notification") {
                console.log("Notification received successfully!");
                fetchNotification();
            }
        } catch (error) {
            console.log("Invalid JSON:", error);
        }
    }, [webSocketMessage]);

    useEffect(() => {
        // if (isInitialRender) {
        //   setIsInitialRender(false); // Mark as rendered
        //   return; // Skip first execution
        // }
        // const fetchdataInUseEffect = async () => {
        fetchNotification();
        // };
        // fetchdataInUseEffect();
    }, [updateIsReadStatus, isLoggedIn]);

    const handleDisplayLogo = (notification) => {
        if (notification?.logo) {
            return notification?.ID &&
                notification?.notificationType.includes("Partner_Onboarding")
                ? generatePartnerRegistrationFile(notification?.logo)
                : generatProfilePicUrl(
                      notification?.logoID,
                      notification?.logo,
                      "Profile_Picture"
                  );
        } else {
            return null;
        }
    };

    return (
        <>
            <AppBar
                position="fixed"
                sx={{
                    zIndex: 1100,
                    background: isHome ? "#fff" : "#fff0",
                    boxShadow: isHome
                        ? "0px 0px 5px hsl(0deg 0% 65.43% / 50%)"
                        : "none" // Custom shadow
                }}
            >
                <Toolbar>
                    {isHome ? (
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={toggleSidebar}
                            sx={{ color: "#000" }} // Toggle sidebar on Menu button click
                        >
                            <MenuIcon sx={{ color: "#000" }} />
                        </IconButton>
                    ) : (
                        ""
                    )}

                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{
                            flexGrow: 1,
                            display: { sm: "block", color: "black" }
                        }}
                    >
                        {isHome ? (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    src={Logo} // Ensure Logo is a valid path or import
                                    alt="Logo"
                                    style={{
                                        width: 74,
                                        height: "auto",
                                        margin: "10px"
                                    }}
                                />
                            </Box>
                        ) : (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <img
                                    src={LogoMm} // Ensure Logo is a valid path or import
                                    alt="LogoMm"
                                    style={{
                                        width: 40,
                                        height: "auto",
                                        marginRight: '10px'
                                    }}
                                />
                                <span>
                                    <Typography
                                        sx={{
                                            fontFamily:
                                                "Abel-Regular, sans-serif",
                                            fontSize: "24px",
                                            fontWeight: "normal",
                                            color: isTextColorBlack
                                                ? "#000"
                                                : "#fff",
                                            display: { xs: "none", sm: "block" }
                                        }}
                                    >
                                        Machine Maze
                                    </Typography>
                                </span>
                            </Box>
                        )}
                    </Typography>

                    {isHome ? (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2, // Adds spacing between icons
                                color: "grey"
                            }}
                        >
                            {/* <Search
              onMouseEnter={() => setShowSearch(true)}
              onMouseLeave={() => setShowSearch(false)}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#fff",
                borderRadius: "5px",
              }}
            >
              <SearchIconWrapper>
                <SearchIcon sx={{ cursor: "pointer" }} />
              </SearchIconWrapper>
              {showSearch && (
                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                  autoFocus // Ensures the input is focused when it appears
                />
              )}
            </Search> */}
                            <IconButton color="inherit" onClick={handleClick}>
                                <Badge
                                    badgeContent={Number(count)}
                                    color="error"
                                >
                                    <NotificationsNoneIcon />
                                </Badge>
                            </IconButton>
                            <IconButton onClick={handleClickProfile}>
                                <Tooltip title="Logout">
                                    <LogoutOutlinedIcon
                                        onClick={handleClickOpenD}
                                    />
                                </Tooltip>

                                <Dialog
                                    open={openD}
                                    onClose={handleCloseD}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle
                                        sx={{ paddingBottom: "5px" }}
                                        fontWeight={"bold"}
                                    >
                                        Log Out
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to log out?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            onClick={handleCloseD}
                                            color="error"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            onClick={handleSignOut}
                                            autoFocus
                                        >
                                            Logout
                                        </Button>
                                    </DialogActions>
                                </Dialog>

                                {/* <ApartmentIcon
              sx={{ cursor: "pointer" }}
              aria-controls={openProfile ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openProfile ? "true" : undefined}
            /> */}
                            </IconButton>
                            {/* <Menu
              id="basic-menu"
              anchorEl={anchorElP}
              open={openProfile}
              onClose={handleCloseProfile}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              sx={{ mt: 2 }}
            >
              <MenuItem>
                <AccountCircleOutlinedIcon
                  sx={{ marginRight: "10px" }}
                ></AccountCircleOutlinedIcon>
                Profile
              </MenuItem>
              <MenuItem onClick={handleSignOut}>
                <LogoutOutlinedIcon sx={{ marginRight: "10px" }} />
                Logout
              </MenuItem>
            </Menu> */}
                        </Box>
                    ) : (
                        ""
                    )}
                </Toolbar>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    sx={{
                        mt: 2,
                        "& .MuiMenu-list": {
                            width: "400px!important",
                            height: "330px"
                        }
                    }}
                >
                    <Typography variant="h6" sx={{ px: 2, py: 1 }}>
                        My Notifications
                    </Typography>
                    {!loading ? (
                        notifications != null &&
                        notifications != undefined &&
                        notifications?.length > 0 &&
                        notifications?.map((notification, index) => {
                            //const imageUrl = handleDisplayLogo(notification);
                            return (
                                <MenuItem
                                    // key={notification?.ID}
                                    key={index}
                                    // sx={{ display: "content", alignItems: "start", gap: 2 }}
                                    sx={{
                                        display: "block",
                                        gap: 2,
                                        backgroundColor: notification?.new
                                            ? "#F0F8FF"
                                            : "transparent", // light highlight
                                        "&:hover": {
                                            backgroundColor: notification?.new
                                                ? "#E6F0FA"
                                                : "#F5F5F5" // subtle hover
                                        }
                                    }}
                                    onClick={() =>
                                        handleNavigation(notification)
                                    }
                                >
                                    <div style={{ display: "flex" }}>
                                        {notification?.imageUrl ? (
                                            <div style={{ padding: "5px" }}>
                                                <img
                                                    loading="lazy"
                                                    src={notification?.imageUrl}
                                                    alt=""
                                                    width={40}
                                                    height={40}
                                                    style={{
                                                        borderRadius: "50%",
                                                        objectFit: "fill"
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div>
                                                <Avatar
                                                    sx={{
                                                        width: "40px",
                                                        height: "40px"
                                                    }}
                                                ></Avatar>
                                            </div>
                                        )}
                                        <div style={{ padding: "5px" }}>
                                            <Box>
                                                <Typography
                                                    variant="body2"
                                                    fontWeight="bold"
                                                    sx={{
                                                        textWrap: "wrap"
                                                    }}
                                                >
                                                    {
                                                        notification?.subjectMessage
                                                    }
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ textWrap: "wrap" }}
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(
                                                            notification?.bodyMessage
                                                        )
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    fontWeight="bold"
                                                    sx={{
                                                        textTransform: "none"
                                                    }}
                                                >
                                                    {new Date(
                                                        notification?.addedTime
                                                    ).toLocaleString("en-US", {
                                                        weekday: "short",
                                                        month: "short",
                                                        day: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true
                                                        // timeZone: "UTC",
                                                    })}
                                                </Typography>
                                            </Box>
                                        </div>
                                        <div style={{ padding: "5px" }}>
                                            {notification?.new && (
                                                <Brightness1Icon
                                                    color="primary"
                                                    sx={{
                                                        fontSize: "12px",
                                                        float: "right"
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </MenuItem>
                            );
                        })
                    ) : (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "20vh" // Ensures it takes up the full height of the viewport
                            }}
                        >
                            <ThreeDot
                                color="#1976d2"
                                size="medium"
                                text=""
                                textColor=""
                            />
                        </Box>
                    )}
                </Menu>
                <PartnerDetailsDrawer
                    open={openDrawer}
                    onClose={handleCloseDrawer}
                    selectedPartner={selectedRow}
                />
            </AppBar>
            {!isHome && (
                <AppBar
                    position="fixed"
                    sx={{
                        top: "auto",
                        bottom: 0,
                        zIndex: 1100,
                        background: isHome ? "#fff" : "#fff0",
                        boxShadow: isHome
                            ? "0px 0px 5px hsl(0deg 0% 65.43% / 50%)"
                            : "none" // Custom shadow
                    }}
                >
                    <Toolbar
                        sx={{
                            justifyContent: "center",
                            display: "grid",
                            textAlign: "center"
                        }}
                    >
                        <Typography color="#fff" marginBottom={"-1.68rem"}>
                            ©2026 Machine Maze
                        </Typography>
                        <div>
                            <Typography variant="caption">
                                {currentVersion}
                            </Typography>
                        </div>
                    </Toolbar>
                </AppBar>
            )}
        </>
    );
};

export default Header;
